import actions from './actions';

const { saveBuild, deleteBuild, loadBuild } = actions;

export default {
  saveBuild,
  deleteBuild,
  loadBuild,
};
